import { connect } from 'react-redux';
import { compose, withHandlers, withProps, withStateHandlers } from 'recompose';

import { closeCurrentModal } from '../modal-reducer';
import { getCommentById } from '../../redux/selectors';
import { CommentsModal as Component } from './component';
import { handleCommentCreate, handleCommentUpdate } from '../../redux/thunk/comments';

const mapStateToProps = (state, { payload }) => ({
  comment: getCommentById(state, payload),
  isLoading: state.comments.isCreating || state.comments.isUpdating || false,
});

export const CommentsModal = compose(
  connect(mapStateToProps, {
    closeCurrentModal,
    handleCommentCreate,
    handleCommentUpdate,
  }),

  withStateHandlers(
    ({ comment: { text = '' } }) => ({ text }),
    {
      setRequestText: () => text => ({ text }),
    },
  ),

  withProps(({ comment }) => ({
    title: comment._id ? 'Update Comment' : 'Add Comment',
  })),

  withHandlers({
    onCloseModal: actions => () => {
      actions.closeCurrentModal();
    },
    onTextChange: ({ setRequestText }) => (event) => {
      setRequestText(event);
    },
    onSave: ({
      text, comment, payload, ...actions
    }) => (event) => {
      event.preventDefault();

      const isUpdating = !!comment._id;

      const { requestId, companyId } = payload;

      const res = isUpdating
        ? actions.handleCommentUpdate(comment._id, { text })
        : actions.handleCommentCreate({ text, requestId, companyId });

      res.then(() => actions.closeCurrentModal());
    },
  }),
)(Component);



// WEBPACK FOOTER //
// ./src/modals/comments-modal/container.js